// data.js
export const studyCenters = [
  {
    name: "suleja",
    levels: {
      "100": ["Economics/SOS", "ISS/SOS", "English/Social Studies", "Hausa/Islamic Studies", "Maths/Computer", "Bio/Inter Sci", "Primary Education (DM)", "ECCE (DM)"],
      "200": ["ISS/SOS", "ECO/SOS", "English/SOS", "English/Arabic Studies", "ECO/Geography", "Bio/Inter Sci", "Arabic/ISS (Eng Medium)", "Maths/Computer", "Primary Education (DM)", "ECCE (DM)", "Arabic/ISS (Arabic Medium)"],
      "300": ["ECO/SOS", "ISS/SOS", "English/SOS", "Hausa/Islamic Studies", "Arabic/ISS (Eng Medium)", "Biology/Computer", "Primary Education (DM)", "ECCE (DM)"],
      "400": ["ISS/SOS", "ECO/SOS", "English/SOS", "Hausa/ISS", "Bio/Geography", "Bio/Computer", "Bio/Maths", "Maths/Computer", "Primary Education (DM)", "ECCE (DM)", "Arabic/ISS (Eng Medium)"],
    },
  },
 {
    name: "Kagara",
    levels: {
      "100": [
        "BIO/ISC",
        "ECCE (DM)",
        "MATHS/COMPUTER",
        "ECONOMICS/SOCIAL STUDIES",
        "ENGLISH/SOCIAL STUDIES",
        "HAUSA/ISLAMIC STUDIES",
        "ISLAMIC STUDIES/SOCIAL STUDIES",
        "PRIMARY EDUCATION STUDIES (PES)",
      ],
      "200": [
        "BIO/ISC",
        "ECCE (DM)",
        "MATHS/COMPUTER",
        "PRIMARY EDUCATION STUDIES (PES)",
        "ECONOMICS/SOCIAL STUDIES",
        "ISLAMIC STUDIES/SOCIAL STUDIES",
        "ENGLISH/SOCIAL STUDIES",
        "ENGLISH/ISLAMIC STUDIES",
      ],
      "300": [
        "ECCE (DM)",
        "ECONOMICS/SOCIAL STUDIES",
        "BIO/ISC",
        "ISLAMIC STUDIES/SOCIAL STUDIES",
        "PRIMARY EDUCATION STUDIES (PES)",
        "MATHS/COMPUTER",
        "ENGLISH/SOCIAL STUDIES",
      ],
      "400": [
        "ECONOMICS/SOCIAL STUDIES",
        "ECCE (DM)",
        "MATHS/COMPUTER",
        "ISLAMIC STUDIES/SOCIAL STUDIES",
        "ENGLISH/SOCIAL STUDIES",
        "CRS/SOCIAL STUDIES",
      ],
    },
  },
  {
    name: "Salka",
    levels: {
      "100": [
        "ISLAMIC/SOCIAL STUDIES",
        "ECONOMICS/SOCIAL STUDIES",
        "PRIMARY EDUCATION STUDIES (DM)",
        "ISC (DM)",
      ],
      "200": [
        "PRIMARY EDUCATION STUDIES (DM)",
        "ECONOMICS/SOCIAL STUDIES",
        "ENGLISH/SOCIAL STUDIES",
        "BIOLOGY/GEOGRAPHY",
        "ISLAMIC/SOCIAL STUDIES",
      ],
      "300": [
        "ISLAMIC/SOCIAL STUDIES",
        "ECONOMICS/SOCIAL STUDIES",
        "PRIMARY EDUCATION STUDIES (DM)",
      ],
      "400": [
        "ECONOMICS/SOCIAL STUDIES",
        "PRIMARY EDUCATION STUDIES (DM)",
      ],
    },
  }, {
    name: "Rijau",
    levels: {
      "100": [
        "ISC (DM)",
        "PHE (DM)",
        "MAT/ECONOMICS",
        "ECONOMICS/SOCIAL STUDIES",
        "ENGLISH/SOCIAL STUDIES",
        "HAUSA/SOCIAL STUDIES",
        "HAUSA/ISLAMIC STUDIES",
        "ISLAMIC STUDIES/SOCIAL STUDIES",
        "PRIMARY EDUCATION STUDIES (PES)",
      ],
      "200": [
        "ISC (DM)",
        "PHE (DM)",
        "MAT/ECONOMICS",
        "PRIMARY EDUCATION STUDIES (PES)",
        "ECONOMICS/SOCIAL STUDIES",
        "ISLAMIC STUDIES/SOCIAL STUDIES",
        "ENGLISH/SOCIAL STUDIES",
        "HAUSA/SOCIAL STUDIES",
        "HAUSA/ISLAMIC STUDIES",
      ],
      "300": [
        "PHE (DM)",
        "ECONOMICS/SOCIAL STUDIES",
        "ISC (DM)",
        "ISLAMIC STUDIES/SOCIAL STUDIES",
        "PRIMARY EDUCATION STUDIES (PES)",
      ],
      "400": [
        "PHE (DM)",
        "ISC (DM)",
        "PRIMARY EDUCATION STUDIES (PES)",
        "ECONOMICS/SOCIAL STUDIES",
        "ENGLISH/SOCIAL STUDIES",
      ],
    },
  },
  {
    name: "Gulu",
    levels: {
      "100": [
        "ISLAMIC/SOCIAL STUDIES",
        "ECONOMICS/SOCIAL STUDIES",
        "PRIMARY EDUCATION STUDIES (DM)",
      ],
      "200": [
        "PRIMARY EDUCATION STUDIES (DM)",
        "ECONOMICS/SOCIAL STUDIES",
      ],
      "300": [
        "ISLAMIC/SOCIAL STUDIES",
        "ECONOMICS/SOCIAL STUDIES",
        "PRIMARY EDUCATION STUDIES (DM)",
      ],
      "400": [
        "ISLAMIC/SOCIAL STUDIES",
        "ECONOMICS/SOCIAL STUDIES",
        "PRIMARY EDUCATION STUDIES (DM)",
      ],
    },
  },
  {
    name: "Mokwa",
    levels: {
      "100": [
        "BIOLOGY/ INTER SCI",
        "ISS/ SOS",
        "ECONOMICS/ SOS",
        "PRIMARY EDU (DM)",
        "PHE (DM)",
        "BUSINESS EDU (DM)",
        
      ],
      "200": [
        "BIOLOGY/ INTER SCI",
        "ENGLISH/ SOS",
        "ECO/ SOS",
        "PRIMARY EDU (DM)",
        "PHE (DM)",
        "BUSINESS EDU (DM)",
        "MATHS (DM)",
      ],
      "300": [
        "BIOLOGY/ INTER SCI",
        "ENGLISH/ SOS",
        "ECO/ SOS",
        "PRIMARY EDU (DM)",
        "PHE (DM)",
      ],
      "400": [
        "PRIMARY EDU (DM)",
        "PHE (DM)",
        "INTER SCI (DM)",
        "ECO/ SOS",
        "ENGLISH / SOS",
      ],
    },
  },
  {
    name: "Gawu",
    levels: {
      "100": [
        "MATH/COMPUTER",
        "PED",
        "ISS/SOS",
        "ECO/SOS",
        "ENG/ISS",
        "ENG/SOS",
        "PHE",
      ],
      "200": [
        "MATH/COMPUTER",
        "PED",
        "ISS/SOS",
        "ECO/SOS",
        "ENG/ISS",
        "ENG/SOS",
        "PHE",
      ],
      "300": [
        "MATH/COMPUTER",
        "PED",
        "ISS/SOS",
        "ECO/SOS",
        "ENG/ISS",
        "ENG/SOS",
        "PHE",
      ],
      "400": [
        "MATH/COMPUTER",
        "PED",
        "ECO/SOS",
        "ENG/SOS",
        "PHE",
      ],
    },
  },
  {
    name: "Katcha",
    levels: {
      "100": [
        "ISLAMIC/SOCIAL STUDIES",
        "ECONOMICS/SOCIAL STUDIES",
        "PRIMARY EDUCATION STUDIES (DM)",
        "ARABIC/ISLAMIC STUDIES",
      ],
      "200": [
        "PRIMARY EDUCATION STUDIES (DM)",
        "ECONOMICS/SOCIAL STUDIES",
        "ISLAMIC/SOCIAL STUDIES",
      ],
      "300": [
        "ISLAMIC/SOCIAL STUDIES",
        "ECONOMICS/SOCIAL STUDIES",
        "PRIMARY EDUCATION STUDIES (DM)",
      ],
      "400": [
        "ECONOMICS/SOCIAL STUDIES",
        "PRIMARY EDUCATION STUDIES (DM)",
      ],
    },
  },
  {
    name: "Doko",
    levels: {
      "100": [
        "MATH/COMPUTER",
        "PED",
        "ISS/ARB",
        "ECO/SOS",
      ],
      "200": [
        "MATH/COMPUTER",
        "PED",
        "ISS/ARB",
        "ECO/SOS",
      ],
      "300": [
        "MATH/COMPUTER",
        "PED",
        "ISS/ARB",
        "ECO/SOS",
      ],
      "400": [
        "PED",
        "ECO/SOS",
      ],
    },
  },{
    name: "New Bussa",
    levels: {
      "100": [
        "ISC (DM)",
        "TED (DM)",
        "MATH/ECONOMICS",
        "ECONOMICS/SOCIAL STUDIES",
        "ENGLISH/SOCIAL STUDIES",
        "BIOLOGY/GEOGRAPHY",
        "MATHS/BIOLOGY",
        "PRIMARY EDUCATION STUDIES (PES)"
      ],
      "200": [
        "ISC (DM)",
        "PRIMARY EDUCATION STUDIES (PES)",
        "MATHS/ECONOMICS",
        "TED (DM)",
        "ECONOMICS/SOCIAL STUDIES",
        "BIOLOGY/GEOGRAPHY",
        "MATHS/BIOLOGY",
        "MATHS/ECONOMICS"
      ],
      "300": [
        "ISC (DM)",
        "ECONOMICS/SOCIAL STUDIES",
        "MATHS/ECONOMICS",
        "TED (DM)",
        "PRIMARY EDUCATION STUDIES (PES)"
      ],
      "400": [
        "PHE (DM)",
        "ISC (DM)",
        "PRIMARY EDUCATION STUDIES (PES)",
        "ECONOMICS/SOCIAL STUDIES",
        "ENGLISH/SOCIAL STUDIES",
        "MATHS/BIOLOGY",
        "BIOLOGY/GEOGRAPHY",
        "MATHS/ECONOMICS"
      ]
    }
  }
  
];
